// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const pib: CountryValidator<"ME"> = createValidator(
  "me.pib",
  124,
);

export default pib;
export const compact = pib.compact;
export const format = pib.format;
export const validate = pib.validate;
export const generate = (): string =>
  pib.generate?.() ??
  (() => {
    throw new Error(
      "Validator me.pib cannot generate values",
    );
  })();
